import { APPLICATIONDETAILS } from "../ENVIRONMENT";

async function applicationSorting(token, currentPage, name, order) {
  // api for candidate application sorting
  const response = await fetch(
    APPLICATIONDETAILS + `?limit=6&page=${currentPage}&${name}=${order}`,
    {
      headers: {
        "Content-Type": "Application/json",
        Authorization: `Bearer ${
          token ? token : sessionStorage.getItem("token")
        }`,
      },
    }
  );
  return response;
}
export { applicationSorting };
